import { render } from "./Activityinfo1.vue?vue&type=template&id=2b65ad91&scoped=true&ts=true"
import script from "./Activityinfo1.vue?vue&type=script&lang=ts"
export * from "./Activityinfo1.vue?vue&type=script&lang=ts"

import "./Activityinfo1.vue?vue&type=style&index=0&id=2b65ad91&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b65ad91"]])

export default __exports__